export default {"src":"/_next/static/media/keplr-missing-logo.12e063bf.svg","height":190,"width":561};